module.exports = __webpack_public_path__ + "static/media/procurement-info.9fb48f06.png";